import { useEffect, useMemo, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useCase } from "../../../contexts/CaseContext";
import { useInquiry } from "../../../contexts/InquiryContext";
import moment from "moment";

export const useCaseDetail = () => {
  const { caseId } = useParams<{ caseId: string }>();
  const { inquiries } = useInquiry();
  const { selectedCase, setSelectedCase, error, loading } = useCase();

  // Memoized inquiry lookup
  const inquiryDate = useMemo(() => {
    if (!selectedCase?.inquiryId || !inquiries) return null;
    const inquiry = inquiries.find(i => i.id === selectedCase.inquiryId);
    return inquiry ? moment(inquiry.dateOfContact).format("LL") : "Unknown";
  }, [selectedCase?.inquiryId, inquiries]);

  // Callback for setting selected case
  const handleSetSelectedCase = useCallback((id: string) => {
    setSelectedCase(id);
  }, [setSelectedCase]);

  useEffect(() => {
    if (caseId) {
      handleSetSelectedCase(caseId);
    }
  }, [caseId, handleSetSelectedCase]);

  return {
    selectedCase,
    loading,
    error,
    inquiryDate,
  };
}; 